export default {"src":"/_next/static/media/route.bb88e06d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};